import { CubeTimeDimensionGranularity } from '../../../common';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';
import { SharedOrgMetricsRequestDto } from '../common/shared-org-metrics-request.dto';

export interface GetAccountSentimentReportAverageTimeSeriesRequestDto {
  params: {
    startDate: string;
    endDate: string;
    granularity?: CubeTimeDimensionGranularity;
  } & SharedOrgMetricsRequestDto;
  config: CubeRequestConfig;
}
